var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"InspectionTemplateQuestionsPseudoTable"},[_c('TemplateSectionTable',{attrs:{"form-errors":_vm.formErrors,"template-data":_vm.templateData,"disabled":_vm.disabled},on:{"update:templateData":function($event){_vm.templateData = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }